<template>
  <slot>
    <div class="header" :class="[container_class]">
        <div class="pre-actions">
            <slot name="close"></slot>
        </div>

        <slot name="header"/>
        <slot name="header_loading" v-if="state === 'loading'"/>
        <slot name="header_success" v-else-if="state === 'success'"/>
        <slot name="header_error"   v-else-if="state === 'error'"/>
        <slot name="header_invalid" v-else-if="state === 'invalid'"/>

        <div class="actions">
            <slot name="actions" />
            <slot name="actions_success" v-if="state === 'success'"/>

            <slot name="actions_over" />
            <slot name="actions_over_success" v-if="state === 'success'"/>
        </div>
    </div>

    <slot name="pre_content"/>
    <slot name="pre_content_success" v-if="state === 'success'"/>

    <main ref="main_element" @blur="onContentBlur()" @click="onContentClick()" tabindex="0" :class='[content_class, "content", container_class]' v-smart-render-scroll>
      <slot name="content" />
      <slot name="content_loading" v-if="state === 'loading'">
        <ContentLoading/>
      </slot>
      <slot name="content_invalid" v-else-if="state === 'invalid'">
        <ContentEmpty
          :text='invalid_text'
          :icon='invalid_icon'
        />
      </slot>
      <slot name="content_error"   v-else-if="state === 'error'">
        <ContentError
          :title_text="error_text"
          @contentErrorRetry="onContentErrorRetry()"
        />
      </slot>
      <slot name="content_success" v-else-if="state === 'success'"/>

    </main>
  </slot>
</template>

<script setup>
  import {ref}                        from 'vue';
  import {defineProps, defineEmits}   from "vue";
  import {onBeforeMount, onUnmounted} from 'vue';
  import ContentLoading               from "@/vue/Elements/Content/ContentLoading.vue";
  import ContentEmpty                 from "@/vue/Elements/Content/ContentEmpty.vue";
  import ContentError                 from "@/vue/Elements/Content/ContentError.vue";
  import PopupController              from "@/js/Webmail/PopupController";

  const emit = defineEmits([
    'errorRetry', 'contentClick', 'contentBlur'
  ]);

  const props = defineProps({
    content_class : {
      default: '',
    },

    invalid_icon : {
      default: 'fas fa-exclamation-circle',
    },

    invalid_text : {
      default: 'global.content.invalid',
    },

    error_text : {
      default: null,
    },

    state : {
      default: null,
    },

    container_class : {
      default: '',
    },
  })

  const main_element = ref();

  onBeforeMount(() => {
    PopupController.broadcaster.on('popup-closed', onPopupClosed);
  })

  onUnmounted(() => {
    PopupController.broadcaster.destroy('popup-closed', onPopupClosed);
  })

  const onPopupClosed = () => {
    main_element.value.focus();
  }

  const onContentClick = () => {
    emit('contentClick')
  }

  const onContentBlur = () => {
    emit('contentBlur')
  }

  const onContentErrorRetry = () => {
    emit('errorRetry')
  }
</script>